import { Box, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import { brandColors } from 'types/colors';

const Toggle = ({ checked, handleChange, disabled = false, offContent = null, onContent = null, sx = {}, inputProps = {} }) => {
  return (
    <Box
      sx={{
        width: '8rem',
        display: 'flex',
        paddingLeft: '1rem',
        alignItems: 'center',
        ...sx,
      }}>
      <Switch
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        inputProps={{ 'aria-label': 'brand toggle', ...inputProps }}
        sx={{
          // marginRight: !checked ?? '2rem',
          // marginLeft: checked ?? '2rem',
          scale: '1.2',
          '.MuiSwitch-thumb': {
            backgroundColor: '#fff',
          },
          '.MuiSwitch-track': {
            backgroundColor: brandColors.GREY,
          },
          '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
              '+ .MuiSwitch-track': {
                backgroundColor: `${brandColors.BLUE} !important`,
              },
              '.MuiSwitch-thumb': {
                backgroundColor: '#fff',
              },
            },
          },
        }}
      />
      {(checked === 0 || checked === false) && (
        <>{offContent !== null ? offContent : <Typography sx={{ fontSize: '.9rem', fontWeight: '600' }}>OFF</Typography>}</>
      )}
      {(checked === 1 || checked === true) && (
        <>
          {onContent !== null ? (
            onContent
          ) : (
            <Typography
              sx={{
                fontSize: '.9rem',
                fontWeight: '600',
              }}>
              ON
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default Toggle;
